<template>
	<ul class="!p-0 !m-0 grid grid-cols-2 gap-3">
		<li
			v-for="(palette, index) in palettes"
			:class="[
				'border-swatch',
				activeSizeIndex === index ? 'border-zinc-700 bg-neutral-100 shadow-md' : 'border-zinc-400 bg-transparent',
			]"
		>
			<button
				type="button"
				@click="handleSelection(index)"
				class="flex flex-col w-full !p-3 h-[60px] lg:h-[75px] items-center justify-center"
				:aria-label="`${palette.title} Button`"
			>
				<h4 class="text-base/[16px] font-normal">{{ palette.title }}</h4>
				<p class="text-xs !m-0 !p-0 lg:max-w-24 text-center">{{ palette.description }}</p>
			</button>
		</li>
	</ul>
	<p v-if="error" class="text-rose-500 bg-rose-500/15 !p-2 !m-0">{{ error }}</p>
	<headless-modal
		ref="downgradeRef"
		id="paletteBuilderDowngradeModal"
		title="Downgrade Palette?"
		title-class="!text-2xl !font-light text-center !mt-4 !mb-0 !pb-0"
		hide-btn
	>
		<template v-slot:content>
			<div class="flex flex-col gap-3">
				<p class="text-xs font-normal !p-0 !m-0 text-neutral-500 text-center">
					If you change palette size, some of your items will be removed.
				</p>
				<button
					type="button"
					class="bg-black text-white uppercase h-12 text-xs w-full font-medium tracking-wider"
					@click="handleSelection(downgradeIndex, true)"
					aria-label="Remove and Downgrade"
				>
					Remove and Downgrade
				</button>
				<button
					type="button"
					class="border border-zinc-400 h-12 uppercase text-xs w-full font-medium tracking-wider"
					@click="handleDismiss"
					aria-label="Keep This Pallete"
				>
					Keep This Pallete
				</button>
			</div>
		</template>
	</headless-modal>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { usePaletteBuilderStore } from '@stores'

const props = defineProps({
	palettes: {
		type: Array,
		required: true,
	},
	selectedPalette: {
		type: Number,
		required: true,
	},
})

const store = usePaletteBuilderStore()
const { error, palettes, activeSizeIndex, downgradeRequiresDrop } = storeToRefs(store)
const { setPalettes, setSelectedPalette, selectActiveIndex } = store

const downgradeRef = ref(null)
const downgradeIndex = ref(0)

onMounted(() => {
	setPalettes(props.palettes)
	setSelectedPalette(props.selectedPalette)
})

const handleSelection = (index, override = false) => {
	if (activeSizeIndex.value === index) return
	if (!override && downgradeRequiresDrop.value(index)) {
		downgradeIndex.value = index
		downgradeRef.value.setIsOpen(true)
		return
	}
	selectActiveIndex(index, override)
	downgradeRef.value.setIsOpen(false)
}
const handleDismiss = () => {
	downgradeIndex.value = 0
	downgradeRef.value.setIsOpen(false)
}
</script>
